var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",attrs:{"id":"body-content"}},[_c('MainHeader'),_c('Banner'),_c('Features'),_c('Pricing'),_c('Reviews'),_c('MainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }